import { Address } from "viem"
import {
  TransactionItemBase,
  TransactionItemUnion,
  TransactionLabel,
} from "./baseTransactionTypes"
import { VaultTransactionItem } from "./vaultTransactionTypes"
// import { ConvertFeesTransaction } from "./vaultTransactionTypes"

export type FeeFlowTransaction = {
  label: TransactionLabel.FEE_FLOW_BUY
  transactions: VaultTransactionItem[]
  vaults: Address[]
  recipient: Address
  epochPeriod: bigint
  deadline: bigint
  maxPrice: bigint
}

export type FeeFlowTransactionItem = TransactionItemBase<FeeFlowTransaction>

export function isFeeFlowTransactionItem(
  transaction?: TransactionItemUnion,
): transaction is FeeFlowTransactionItem {
  return transaction?.label === TransactionLabel.FEE_FLOW_BUY
}
